import React, { useEffect } from 'react';
import PortalOverlay, { PortalOverlayModal } from '../../../../ui/PortalOverlay';
import { Stack } from '../../../../ui';
import analytics from '../../../../../modules/analytics';
import type { ProAppointment } from '../../../../../api/Providers/Appointments';

import CancelAppointmentModalHeader from './CancelAppointmentModalHeader';
import CancelAppointmentModalWarningMessage from './CancelAppointmentModalWarningMessage';
import CancelAppointmentModalMainMessage from './CancelAppointmentModalMainMessage';
import CancelAppointmentModalButtons from './CancelAppointmentModalButtons';

export type CancelAppointmentModalProps = {
  inCancellationWindow: boolean;
  in24HourCancellationWindow: boolean;
  proLateCancellationFeePercent: number,
  proCanCancel: boolean;
  appointment: ProAppointment;
  closeCancelAppointmentModal: (confirmedCancel: boolean) => void;
  onCancelAppointmentClick: () => void;
  onSmsClick: () => void;
  visible: boolean;
};

const Modal: React.FC<CancelAppointmentModalProps> = ({
  inCancellationWindow,
  in24HourCancellationWindow,
  proLateCancellationFeePercent,
  proCanCancel,
  appointment,
  closeCancelAppointmentModal,
  onCancelAppointmentClick,
  onSmsClick,
  visible,
}) => {
  useEffect(() => {
    if (!visible) return;
    analytics.track(
      'Cancel Appointment Modal Viewed',
      {
        appointment_id: appointment.id,
        provider_id: appointment.provider,
        client_id: appointment.client.id,
      },
    );
  }, [
    visible,
    appointment,
  ]);

  return (
    <PortalOverlay name="cancel-appointment-modal-backdrop">
      <PortalOverlayModal
        position="menu"
        testID="cancel-appointment-modal-dialog"
      >
        <CancelAppointmentModalHeader />
        <Stack
          space={24}
        >
          <CancelAppointmentModalWarningMessage
            inCancellationWindow={inCancellationWindow}
            proCanCancel={proCanCancel}
            appointment={appointment}
          />
          <CancelAppointmentModalMainMessage
            inCancellationWindow={inCancellationWindow}
            proLateCancellationFeePercent={proLateCancellationFeePercent}
            in24HourCancellationWindow={in24HourCancellationWindow}
            proCanCancel={proCanCancel}
            appointment={appointment}
          />
          <CancelAppointmentModalButtons
            inCancellationWindow={inCancellationWindow}
            proCanCancel={proCanCancel}
            appointment={appointment}
            onKeepAppointmentClick={() => closeCancelAppointmentModal(false)}
            onSmsClick={() => {
              onSmsClick();
              closeCancelAppointmentModal(true);
            }}
            onCancelAppointmentClick={() => {
              onCancelAppointmentClick();
              closeCancelAppointmentModal(true);
            }}
          />
        </Stack>
      </PortalOverlayModal>
    </PortalOverlay>
  );
};

export default Modal;
